var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('input',{staticClass:"float-left",staticStyle:{"margin":"2px 8px 2px 2px"},attrs:{"type":"checkbox","name":_vm.name,"id":_vm.id},domProps:{"value":_vm.value,"checked":_vm.checked},on:{"change":function($event){return _vm.updateValue({
    objectType: _vm.objectType,
    key       : _vm.propertyKey,
    value     : $event.target.checked ? 1 : 0,
    index     : _vm.index
  })}}})}
var staticRenderFns = []

export { render, staticRenderFns }